// TradeZakatCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import TradeZakatTable from "./TradeZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Trade_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Zakat Perdagangan - Hitung Zakat Usaha Dagang Anda dengan Akurat";
const DESCRIPTION =
  "Kalkulator Zakat Perdagangan adalah alat hitung yang dirancang untuk memudahkan proses penghitungan jumlah zakat yang wajib dikeluarkan atas harta perdagangan sesuai dengan prinsip syariah. Kalkulator ini bertujuan untuk memberikan solusi cepat dan akurat bagi individu dan pedagang yang ingin menentukan jumlah zakat yang wajib dikeluarkan sesuai dengan standar syariah yang berlaku.";
const KEYWORDS = "zakat perdagangan, zakat usaha dagang ";
const OG_URL = "https://do-calculate.com/calculator/id/trade-zakat/";
const apiEndpoint = `${SERVER_URL}/${Trade_Zakat_EndPoint}`;
function TradeZakatCalculator() {
  const [cash, setCash] = useState(0);
  const [yearType, setYearType] = useState("");
  const [gramPriceGold, setGramPriceGold] = useState(0);
  const [gramPriceSilver, setGramPriceSilver] = useState(0);
  const [debtsReceivable, setDebtsReceivable] = useState(0);
  const [debtsPayable, setDebtsPayable] = useState(0);
  const [merchandise, setMerchandise] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [thresholdType, setThresholdType] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleThresholdTypeChange = (event) => {
    const newThresholdType = event.target.value;
    setThresholdType(newThresholdType);
    if (newThresholdType === "gold") {
      setGramPriceSilver(0);
    } else if (newThresholdType === "silver") {
      setGramPriceGold(0);
    }
  };
  const handleYearTypeChange = (event) => {
    setYearType(event.target.value);
  };
  const handleCashChange = (event) => {
    setCash(event.target.value);
  };
  const handleDebtsReceivableChange = (event) => {
    setDebtsReceivable(event.target.value);
  };
  const handleMerchandiseChange = (event) => {
    setMerchandise(event.target.value);
  };
  const handleDebtsPayableChange = (event) => {
    setDebtsPayable(event.target.value);
  };
  const handleGramPriceGoldChange = (event) => {
    setGramPriceGold(event.target.value);
  };
  const handleGramPriceSilverChange = (event) => {
    setGramPriceSilver(event.target.value);
  };
  const calculateTradeZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          merchandise,
          cash,
          debtsReceivable,
          debtsPayable,
          yearType,
          gramPriceGold,
          gramPriceSilver,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Hitung Zakat Usaha Dagang</h1>
          </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Kalkulator Zakat Perdagangan adalah alat hitung yang dirancang untuk memudahkan proses penghitungan jumlah zakat yang wajib dikeluarkan atas harta perdagangan sesuai dengan prinsip syariah. Kalkulator ini bertujuan untuk memberikan solusi cepat dan akurat bagi individu dan pedagang yang ingin menentukan jumlah zakat yang wajib dikeluarkan sesuai dengan standar syariah yang berlaku.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Zakat Usaha Dagang
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Jenis Tahun</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Masehi
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            id="hijri"
                                            value="hijri"
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijriah
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='merchandiseNumber' className="form-label ms-2">Barang Dagangan </label>
                                    </b>
                                    <input
                                        type="number"
                                        id="merchandiseNumber"
                                        value={merchandise}
                                        onChange={handleMerchandiseChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='cashNumber' className="form-label ms-2">Total Uang (Tunai)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="cashNumber"
                                        value={cash}
                                        onChange={handleCashChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='debtsReceivableNumber' className="form-label ms-2">Piutang yang Diharapkan Tertagih</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="debtsReceivableNumber"
                                        value={debtsReceivable}
                                        onChange={handleDebtsReceivableChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='debtsPayableNumber' className="form-label ms-2">Utang yang Dimiliki Pedagang</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="debtsPayableNumber"
                                        value={debtsPayable}
                                        onChange={handleDebtsPayableChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='thresholdType' >Jenis Nisab</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="gold"
                                            id="gold"
                                            checked={thresholdType === "gold"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gold">
                                            Emas
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="silver"
                                            id="silver"
                                            checked={thresholdType === "silver"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="silver">
                                            Perak
                                        </label>
                                    </div>
                                </div>
                                <br />
                                {thresholdType === "gold" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceSilver == 0}
                                        <b>
                                            <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">Harga gram emas (24 karat)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceGoldNumber"
                                            value={gramPriceGold}
                                            onChange={handleGramPriceGoldChange}
                                            className="form-control ml-2"
                                            style={{ width: '90%' }}
                                        />
                                    </div>
                                )}
                                {thresholdType === "silver" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceGold == 0}
                                        <b>
                                            <label htmlFor='gramPriceSilverNumber' className="form-label ms-2">Harga gram perak (kadar 99.9)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceSilverNumber"
                                            value={gramPriceSilver}
                                            onChange={handleGramPriceSilverChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                <br/>                                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateTradeZakat}
                       >
                    Hitung
                    </button>              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi kesalahan :</u>
                    </b>{" "}
                    Harap isi semua bidang dengan benar.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Hasil:{" "}
                      </div>
                    </h4>
                    <hr />
                    <TradeZakatTable result={result}></TradeZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Deskripsi Kalkulator Zakat Usaha Dagang </div>
              <div className="info-section-body">
                <u>
                  <b> Kalkulator Usaha Dagang </b>{" "}
                </u>{" "}
                <br/>                Kalkulator Zakat Perdagangan adalah alat yang digunakan untuk menghitung jumlah zakat yang wajib dikeluarkan atas harta perdagangan. Kalkulator ini dikembangkan dengan mempertimbangkan barang dagangan yang dimiliki, uang tunai, piutang yang dimiliki pedagang, dan utang yang dimiliki pedagang, jenis tahun (Hijriah atau Masehi), serta harga emas dan perak untuk menghitung batas minimum harta yang terkena zakat. Kalkulator ini didasarkan pada aturan syariah tertentu untuk menghitung jumlah zakat yang wajib dikeluarkan dengan persentase tertentu dari nilai harta.
                <br/>                Kalkulator Zakat Perdagangan mencakup beberapa komponen dan kriteria untuk menghitung zakat dengan benar. Data dasar yang dimasukkan ke dalam kalkulator meliputi:
                <ul>
                  <li>
                    Barang dagangan yang dimiliki: Nilai barang dagangan yang dimiliki pedagang dalam periode tertentu, termasuk barang yang disimpan, dijual, dan dibeli.
                  </li>
                  <li>
                    Uang tunai: Nilai uang tunai yang dimiliki pedagang di rekening bank atau uang tunai yang tersedia untuk pembayaran.
                  </li>
                  <li>
                    Piutang yang dimiliki pedagang: Jumlah yang menjadi hak pedagang dan pemasok yang belum dibayarkan hingga saat ini.
                  </li>
                  <li>
                    Utang yang dimiliki pedagang: Jumlah yang menjadi hak pelanggan dan pembeli yang belum diterima hingga saat ini.
                  </li>
                  <li>
                    Jenis tahun: Jenis tahun yang digunakan untuk menghitung zakat, baik Hijriah maupun Masehi.
                  </li>
                  <li>
                    Harga emas dan perak: Harga emas dan perak saat ini digunakan untuk menghitung batas minimum harta yang terkena zakat. Ini didasarkan pada berat standar emas dan perak serta nilainya berdasarkan berat.
                  </li>
                </ul>
                <br/>                Setelah memasukkan data ini, kalkulator mengonversinya menjadi angka dan menghitung batas minimum harta yang terkena zakat berdasarkan harga emas dan perak yang diberikan. Kemudian zakat dihitung dengan persentase tertentu dari nilai harta yang dihitung berdasarkan aturan syariah. Kalkulator menampilkan hasil perhitungan dengan jelas seperti jumlah zakat yang wajib dikeluarkan, harta yang wajib dizakati, dan batas minimum yang dihitung.
                <br/>                Kalkulator Zakat Perdagangan memungkinkan individu dan pedagang untuk menghitung zakat dengan mudah dan cepat, membantu mereka mematuhi prinsip syariah dan aturan penting dalam membayar zakat. Kalkulator ini dapat digunakan dalam aplikasi smartphone, situs web, atau program khusus untuk menghitung zakat perdagangan, memberikan kenyamanan dan akurasi dalam proses penghitungan zakat serta meningkatkan kepatuhan terhadap persyaratan syariah.
                <br />
                <hr />
                <b>Tanggal revisi terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default TradeZakatCalculator;